"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var factorySvgIcon_1 = __importDefault(require("./utils/factorySvgIcon"));
var SvgLinkPlus = function (props) {
    var color = props.color;
    return (React.createElement(React.Fragment, null,
        React.createElement("g", { clipPath: "url(#Outline_svg__a)" },
            React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 20a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm10-8c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Z", fill: color })),
        React.createElement("path", { d: "M12.09 14.429c.036.893-.543 1.49-1.553 1.571H7V8.304h1.96v6.125h3.13ZM12.595 8.464c.53-.086 1.281-.16 2.329-.16 1.06 0 1.824.204 2.335.616.487.382.807 1.017.801 1.769-.006.745-.253 1.386-.709 1.805-.591.555-1.472.807-2.483.807-.228 0-.431-.012-.591-.037L14.264 16h-1.712l.043-7.536Zm1.688 3.463c.142.031.32.043.573.043.918 0 1.485-.462 1.491-1.238.006-.703-.474-1.122-1.343-1.122-.34 0-.58.031-.703.056l-.018 2.261Z", fill: color }),
        React.createElement("defs", null,
            React.createElement("clipPath", { id: "Outline_svg__a" },
                React.createElement("path", { fill: "#fff", transform: "translate(2 2)", d: "M0 0h20v20H0z" })))));
};
exports.default = factorySvgIcon_1.default(SvgLinkPlus);
//# sourceMappingURL=SvgLinkPlus.js.map